import Layout from "@/ux/layout/Layout.vue";
import Users from "@/ux/users/UsersView.vue";
import Advances from "@/ux/advances/AdvancesView.vue";
import Payments from "@/ux/payments/PaymentsView.vue";
import SharedSamples from "@/ux/sharedSamples/SharedSamplesView.vue";
import Files from "@/ux/files/FilesView.vue";
import Banners from "@/ux/banners/BannersView.vue";
import News from "@/ux/news/NewsView.vue";
import Notifications from "@/ux/notifications/NotificationsView.vue";
import Campaigns from "@/ux/campaigns/CampaignsView.vue";
import SampleBook from "@/ux/sampleBook/SampleBookView.vue";
import Events from "@/ux/events/EventsView.vue";
import Download from "@/ux/download/DownloadView.vue";
import { isAuthenticate } from "@/router/guards";

export const generalRoutes = [
  {
    path: "/",
    component: Layout,
    beforeEnter: isAuthenticate,
    children: [
      {
        path: "users",
        component: Users,
      },
      {
        path: "advances",
        component: Advances,
      },
      {
        path: "payments",
        component: Payments,
      },
      {
        path: "shared-samples",
        component: SharedSamples,
      },
      {
        path: "files",
        component: Files,
      },
      {
        path: "banners",
        component: Banners,
      },
      {
        path: "news",
        component: News,
      },
      {
        path: "notifications",
        component: Notifications,
      },
      {
        path: "campaigns",
        component: Campaigns,
      },
      {
        path: "sample-book",
        component: SampleBook,
      },
      {
        path: "events",
        component: Events,
      },
    ],
  },
  {
    path: "/store",
    component: Download,
  },
];
